export default __webpack_public_path__ + "static/media/flyer-jak-series-poster.c7cff6ad.png";